<div class="bgCard">

    <div class="dilogStl">
        <h1 class="viewHeading" mat-dialog-title>View User Order</h1>
        <button align="end" mat-icon-button mat-dialog-close>
            <mat-icon style="color:#0038FF" svgIcon="feather:x"></mat-icon>
        </button>
    </div>

    <mat-dialog-content class="mat-typography">

        <div class="card dataCard mt-1">
            <div class="mt-2 ml-3">
                <h1 class="headings">
                    Basic Details
                </h1>
                <div class="row m-3">
                    <div class="row mb-1">
                        <div class="col-sm-12 col-md-3">
                            <div class="listFont fw-bold">
                                User Name:
                            </div>
                            <div class="fw-bold">
                                {{userOrderCompleteInfo.user.full_name}}
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3">
                            <div class="listFont fw-bold">
                                User Email:
                            </div>
                            <div class="fw-bold">
                                {{userOrderCompleteInfo.user.email}}
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3">
                            <div class="listFont fw-bold">
                                User Mobile:
                            </div>
                            <div class="fw-bold">
                                {{userOrderCompleteInfo.user.mobile_number}}
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-sm-12 col-md-3">
                            <div class="listFont fw-bold">
                                Plan Name:
                            </div>
                            <div class="fw-bold">
                                {{userOrderCompleteInfo.plan_duration.plan.name}}
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3">
                            <div class="listFont fw-bold">
                                Plan Months:
                            </div>
                            <div class="fw-bold">
                                {{userOrderCompleteInfo.plan_duration.validity_in_months}}
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3">
                            <div class="listFont fw-bold">
                                Is Hourly:
                            </div>
                            <div class="fw-bold">
                                <mat-checkbox [checked]="userOrderCompleteInfo.plan_duration.plan.is_hourly" [disabled]="true"></mat-checkbox>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3" *ngIf="isHourly">
                            <div class="listFont fw-bold">
                                Allowed Time:
                            </div>
                            <div class="fw-bold">
                                {{userOrderCompleteInfo.plan_duration?.total_allowed_duration_in_secs | secondsToHms}}
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3" *ngIf="isHourly">
                            <div class="listFont fw-bold">
                                Used Time:
                            </div>
                            <div class="fw-bold">
                                {{userOrderCompleteInfo.total_time_used_in_secs | secondsToHms}}
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3" *ngIf="isHourly">
                            <div class="listFont fw-bold">
                                Remaining Time:
                            </div>
                            <div class="fw-bold">
                                {{userOrderCompleteInfo.remaining_time_in_secs | secondsToHms}}
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3" *ngIf="!isHourly">
                            <div class="listFont fw-bold">
                                Slot Days:
                            </div>
                            <div class="fw-bold">
                                {{userOrderCompleteInfo.plan_duration.plan.slot_booking_days.join()}}
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3">
                            <div class="listFont fw-bold">
                                Plan Price:
                            </div>
                            <div class="fw-bold">
                                {{userOrderCompleteInfo.plan_duration.price}}
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3">
                            <div class="listFont fw-bold">
                                SGST:
                            </div>
                            <div class="fw-bold">
                                {{userOrderCompleteInfo.plan_duration.sgst_tax_price}}
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3">
                            <div class="listFont fw-bold">
                                CGST:
                            </div>
                            <div class="fw-bold">
                                {{userOrderCompleteInfo.plan_duration.cgst_tax_price}}
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-3">
                            <div class="listFont fw-bold">
                                IGST:
                            </div>
                            <div class="fw-bold">
                                {{userOrderCompleteInfo.plan_duration.igst_tax_price}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card dataCard mt-4">
            <div class="mt-2 ml-3">
                <h1 class="headings">
                    User Order Details
                </h1>
                <div class="row m-3">
                    <div class="col-sm-12 col-md-3">
                        <div class="listFont fw-bold">Branch:</div>
                        <div class="fw-bold">{{userOrderCompleteInfo.branch.name}}</div>
                    </div>
                    <div class="col-sm-12 col-md-3">
                        <div class="listFont fw-bold">Start Date:</div>
                        <div class="fw-bold">{{userOrderCompleteInfo.start_date | dateFormat}}</div>
                    </div>
                    <div class="col-sm-12 col-md-3">
                        <div class="listFont fw-bold">End Date:</div>
                        <div class="fw-bold">{{userOrderCompleteInfo.end_date | dateFormat}}</div>
                    </div>
                    <div class="col-sm-12 col-md-3" *ngIf="isHourly && userOrderCompleteInfo.deductible_time_in_secs">
                        <div class="listFont fw-bold">Time Slot:</div>
                        <div class="fw-bold">{{userOrderCompleteInfo.deductible_time_in_secs | secondsToHms}}</div>
                    </div>
                    <div class="col-sm-12 col-md-3" *ngIf="userOrderCompleteInfo.time_slot">
                        <div class="listFont fw-bold">Time Slot:</div>
                        <div class="fw-bold">{{userOrderCompleteInfo.time_slot?.name}}</div>
                    </div>
                    <div class="col-sm-12 col-md-3" *ngIf="userOrderCompleteInfo.plan_status">
                        <div class="listFont fw-bold">Plan Status:</div>
                        <div class="fw-bold">{{userOrderCompleteInfo?.plan_status | sentenceWithUnderscoreTitleCase}}</div>
                    </div>
                    <div class="col-sm-12 col-md-3" *ngIf="userOrderCompleteInfo.expiry_reason">
                        <div class="listFont fw-bold">Expiry Reason:</div>
                        <div class="fw-bold">{{userOrderCompleteInfo?.expiry_reason | sentenceWithUnderscoreTitleCase}}</div>
                    </div>
                    <div class="col-sm-12 col-md-3" *ngIf="!isHourly">
                        <div class="listFont fw-bold">Reschedules Per Month:</div>
                        <div class="fw-bold">{{userOrderCompleteInfo.no_of_reschedules_per_month}}</div>
                    </div>
                    <div class="col-sm-12 col-md-3" *ngIf="userOrderCompleteInfo.coupon">
                        <div class="listFont fw-bold">Coupon Name:</div>
                        <div class="fw-bold">{{userOrderCompleteInfo.coupon?.name}}</div>
                    </div>
                    <div class="col-sm-12 col-md-3" *ngIf="userOrderCompleteInfo.coupon">
                        <div class="listFont fw-bold">Coupon Code:</div>
                        <div class="fw-bold">{{userOrderCompleteInfo.coupon?.coupon_code}}</div>
                    </div>
                    <div class="col-sm-12 col-md-3" *ngIf="userOrderCompleteInfo.assigned_trainer">
                        <div class="listFont fw-bold">Assigned Trainer:</div>
                        <div class="fw-bold">{{userOrderCompleteInfo.assigned_trainer?.full_name}}</div>
                    </div>
                    <div class="col-sm-12 col-md-3" *ngIf="userOrderCompleteInfo.created_at">
                        <div class="listFont fw-bold">Created At:</div>
                        <div class="fw-bold">{{userOrderCompleteInfo.created_at | dateTimeFormat}}</div>
                    </div>
                    <div class="row  mt-4">
                        <h1 class="headings">
                            Plan Calculation & Segregation Summary:
                        </h1>
                        <div class="col-sm-12 col-md-6">
                            <div class="row">
                                <div class="col-sm-6 listFont fw-bold text-end">Plan price:</div>
                                <div class="col-sm-6  fw-bold text-start">{{userOrderCompleteInfo.plan_duration.price}}</div>
                            </div>
                            <div class="row" *ngIf="userOrderCompleteInfo.timeslot_discount_price">
                                <div class="col-sm-6 listFont fw-bold text-end">TimeSlot Discount:</div>
                                <div class="col-sm-6  fw-bold text-start">-{{userOrderCompleteInfo.timeslot_discount_price}}</div>
                            </div>
                            <div class="row" *ngIf="userOrderCompleteInfo.coupon_discount_price">
                                <div class="col-sm-6 listFont fw-bold text-end">Coupon Discount:</div>
                                <div class="col-sm-6  fw-bold text-start">-{{userOrderCompleteInfo.coupon_discount_price}}</div>
                            </div>
                            <div class="row" *ngIf="userOrderCompleteInfo.timeslot_discount_price || userOrderCompleteInfo.coupon_discount_price">
                                <div class="col-sm-6 listFont fw-bold text-end">Taxable Plan price:</div>
                                <div class="col-sm-6  fw-bold text-start">{{userOrderCompleteInfo.plan_price}}</div>
                            </div>
                            <div class="row" *ngIf="userOrderCompleteInfo.sgst_tax_price">
                                <div class="col-sm-6 listFont fw-bold text-end">SGST:</div>
                                <div class="col-sm-6 fw-bold text-start">+{{userOrderCompleteInfo.sgst_tax_price}}</div>
                            </div>
                            <div class="row" *ngIf="userOrderCompleteInfo.cgst_tax_price">
                                <div class="col-sm-6 listFont fw-bold text-end">CGST:</div>
                                <div class="col-sm-6 fw-bold text-start">+{{userOrderCompleteInfo.cgst_tax_price}}</div>
                            </div>
                            <div class="row" *ngIf="userOrderCompleteInfo.igst_tax_price">
                                <div class="col-sm-6 listFont fw-bold text-end">IGST:</div>
                                <div class="col-sm-6 fw-bold text-start">+{{userOrderCompleteInfo.igst_tax_price}}</div>
                            </div>
                            <div class="row" *ngIf="userOrderCompleteInfo.wallet_points_used">
                                <div class="col-sm-6 listFont fw-bold text-end">Wallet Points:</div>
                                <div class="col-sm-6 fw-bold text-start">-{{userOrderCompleteInfo.wallet_points_used}}</div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6 listFont fw-bold text-end">Total Amount Payable:</div>
                                <div class="col-sm-6 fw-bold text-start">{{userOrderCompleteInfo.total_price}}</div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 justify-content-center">
                            <table class="table " style="width: 70%;">
                                <thead class="thead-dark" style="background: #000;color: #fff; position: sticky; top: 0; z-index: 1;">
                                    <tr>
                                        <th scope="col">Total Amount Paid:</th>
                                        <th scope="col">Plan Amount Segregated:</th>
                                        <th scope="col">SGST Amount Segregated:</th>
                                        <th scope="col">CGST Amount Segregated:</th>
                                        <th scope="col">IGST Amount Segregated:</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{userOrderCompleteInfo.total_price}}</td>
                                        <td>{{userOrderCompleteInfo.plan_price_segregated}}</td>
                                        <td>{{userOrderCompleteInfo.sgst_tax_price_segregated}}</td>
                                        <td>{{userOrderCompleteInfo.cgst_tax_price_segregated}}</td>
                                        <td>{{userOrderCompleteInfo.igst_tax_price_segregated}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card dataCard mt-4" *ngIf="userOrderCompleteInfo.plan_cancel_info">
            <div class="mt-2 ml-3">
                <h1 class="headings">
                    Cancellation Details
                </h1>
                <div class="row m-3">
                    <div class="col-sm-12 col-md-3">
                        <div class="listFont fw-bold">Cancelled On:</div>
                        <div class="fw-bold">{{userOrderCompleteInfo.plan_cancel_info?.cancel_date | dateFormat}}</div>
                    </div>
                    <div class="col-sm-12 col-md-3">
                        <div class="listFont fw-bold">Cancellation Fee:</div>
                        <div class="fw-bold">{{userOrderCompleteInfo.plan_cancel_info?.cancel_fee_amount}}</div>
                    </div>
                    <div class="col-sm-12 col-md-3">
                        <div class="listFont fw-bold">Wallet Points Credited:</div>
                        <div class="fw-bold">{{userOrderCompleteInfo.plan_cancel_info?.wallet_points_credited}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card dataCard mt-4" *ngIf="userOrderCompleteInfo.plan_extensions.length > 0">
            <div class="mt-2 ml-3">
                <h1 class="headings">
                    Plan Extensions
                </h1>
                <div class="row m-3 justify-content-center">
                    <table class="table " style="width: 70%;">
                        <thead class="thead-dark" style="background: #000;color: #fff; position: sticky; top: 0; z-index: 1;">
                            <tr>
                                <th scope="col">Extension Reason</th>
                                <th scope="col">Extension Message</th>
                                <th scope="col">Extended From</th>
                                <th scope="col">Extended To</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of userOrderCompleteInfo.plan_extensions">
                                <td>{{item.extension_reason_type | sentenceWithUnderscoreTitleCase}}</td>
                                <td>{{item.extension_message}}</td>
                                <td>{{item.extended_from_date | dateFormat}}</td>
                                <td>{{item.extended_to_date | dateFormat}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="card dataCard mt-4" *ngIf="userOrderCompleteInfo.payments.length > 0">
            <div class="mt-2 ml-3">
                <h1 class="headings">
                    Plan Payments
                </h1>
                <div class="row m-3 justify-content-center">
                    <table class="table " style="width: 85%;">
                        <thead class="thead-dark" style="background: #000;color: #fff; position: sticky; top: 0; z-index: 1;">
                            <tr>
                                <th scope="col">Payment Gateway</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Payment Status</th>
                                <th scope="col">Payment Success At</th>
                                <th scope="col">Created At</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of userOrderCompleteInfo.payments">
                                <td>{{item.payment_gateway_merchant | sentenceWithUnderscoreTitleCase}}</td>
                                <td>{{item.amount}}</td>
                                <td>{{item.payment_status | sentenceWithUnderscoreTitleCase}}</td>
                                <td>{{item.payment_success_at | dateTimeFormat}}</td>
                                <td>{{item.created_at | dateTimeFormat}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </mat-dialog-content>
</div>